import './style.scoped.css';

interface TabBarProps {
  data: any[];
  activeTab?: number;
  onChangeTab?: (tab: number) => void;
  scrollable?: boolean;
  classes?: any[];
}
const TabBar = (props: TabBarProps) => {
  const { data, activeTab = 0, onChangeTab, scrollable = false, classes = undefined } = props;

  const _handleChangeTab = (tabIndex: number) => {
    if (activeTab != tabIndex && onChangeTab) {
      onChangeTab(tabIndex);
    }
  };

  const _getTabItemClassName = (isActive: boolean, scrollable: boolean) => {
    if (isActive && !scrollable) {
      return classes ? classes[0] : 'tabItemActive';
    } else if (isActive && scrollable) {
      return (classes ? classes[0] : 'tabItemActive') + ' mr-2';
    } else if (!isActive && !scrollable) {
      return classes ? classes[1] :'tabItemInactive';
    } else {
      return (classes ? classes[1] : 'tabItemInactive') + '  mr-2';
    }
  };

  const _renderTab = (item, index) => {
    const isActive = activeTab == index;
    return (
      <div
        className={_getTabItemClassName(isActive, scrollable)}
        key={index}
        onClick={() => _handleChangeTab(index)}
      >
        {item.name}
      </div>
    );
  };

  if (!scrollable) {
    return (
      <div
        className={`grid grid-flow-row grid-cols-${data.length} grid-rows-1 gap-3`}
      >
        {data.map(_renderTab)}
      </div>
    );
  }

  return <div className={'scrollTabContainer'}>{data.map(_renderTab)}</div>;
};

export default TabBar;
